import { render, staticRenderFns } from "./PdfTable.vue?vue&type=template&id=67d422ff&scoped=true"
import script from "./PdfTable.vue?vue&type=script&lang=js"
export * from "./PdfTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d422ff",
  null
  
)

export default component.exports